export const BOOKING_ENGINE_ENTRIES = {
  PRICE_CALENDAR: 'PriceCalendar',
  PRICE_REMOTE: 'PriceRemote',
  QUICK_SEARCH: 'QuickSearch',
  CRUISE_BOOKING: 'CruiseBooking',
};
export const BOOKING_TRACKING_UPSELL_REVENUE = 'BOOKING_TRACKING_UPSELL_REVENUE';
export type BookingEngineEntry =
  (typeof BOOKING_ENGINE_ENTRIES)[keyof typeof BOOKING_ENGINE_ENTRIES];
